import { combineReducers } from '@reduxjs/toolkit';
import { appealReducer as appeal } from '../slices/appeal-slice';
import { applicationReducer as application } from '../slices/application-slice';
import { attestationReducer as attestation } from '../slices/attestation-slice';
import { authReducer as auth } from '../slices/auth-slice';
import { currentLocaleReducer as currentLocale } from '../slices/currentLocaleSlice';
import { directionReducer as direction } from '../slices/direction-slice';
import { districtReducer as district } from '../slices/district-slice';
import { faqReducer as faq } from '../slices/faq-slice';
import { jobReducer as job } from '../slices/job-slice';
import { locationReducer as location } from '../slices/location-slice';
import { newsReducer as news } from '../slices/news-slice';
import { notificationsReducer as notifications } from '../slices/notifications-slice';
import { organizationReducer as organization } from '../slices/organization-slice';
import { questionReducer as question } from '../slices/question-slice';
import { regionReducer as region } from '../slices/region-slice';
import { scheduleReducer as schedule } from '../slices/schedule-slice';
import { userReducer as user } from '../slices/user-slice';

export const rootReducer = combineReducers({
  currentLocale,
  auth,
  application,
  appeal,
  attestation,
  direction,
  district,
  location,
  organization,
  region,
  schedule,
  user,
  job,
  question,
  faq,
  news,
  notifications,
});
